import React from 'react';
import './PayoutsPage.css';

const PayoutsPage: React.FC = () => {
  return (
    <div className="payouts-page" data-testid="payouts-page">
      <div className="payouts-page__header">
        <h1 className="payouts-page__title">Выплаты</h1>
      </div>
      <div className="payouts-page__content">
        <div className="payouts-page__placeholder">
          <span className="payouts-page__placeholder-icon">💰</span>
          <p className="payouts-page__placeholder-text">
            Здесь будет управление выплатами контрагентам: реестры выплат, комиссии, тарифы и финансовый учёт.
          </p>
        </div>
      </div>
    </div>
  );
};

PayoutsPage.displayName = 'PayoutsPage';

export default PayoutsPage;
